var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuoteBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 458,
    viewBox: "0 0 486 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 462,
    height: 426,
    fill: "#FFFBF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.506 270.444C457.779 302.045 443.362 338.794 414.528 355.668C370.99 381.183 374.634 420.412 289.644 437.467C277.25 440.014 264.617 441.208 251.965 441.028C245.773 440.914 239.594 440.409 233.466 439.516C179.45 431.631 143.101 394.088 129.765 348.758C112.219 289.155 147.259 250.1 170.483 226.619C193.708 203.137 210.725 129.851 294.142 112.463C306.866 109.732 319.862 108.479 332.872 108.728C362.553 109.484 394.925 119.206 417.325 139.543C419.003 141.055 420.641 142.637 422.239 144.29C453.371 176.261 466.601 227.36 461.506 270.444Z",
    fill: "#F9A200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M461.506 270.444C457.779 302.045 443.362 338.794 414.528 355.668C370.99 381.183 374.634 420.412 289.644 437.467C277.25 440.014 264.617 441.208 251.965 441.028C245.773 440.914 239.594 440.409 233.466 439.516C179.45 431.631 143.101 394.088 129.765 348.758C112.219 289.155 147.259 250.1 170.483 226.619C193.708 203.137 210.725 129.851 294.142 112.463C306.866 109.732 319.862 108.479 332.872 108.728C362.553 109.484 394.925 119.206 417.325 139.543C419.003 141.055 420.641 142.637 422.239 144.29C453.371 176.261 466.601 227.36 461.506 270.444Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.688 430.86H467.932",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M371.942 135.49H400.746C400.746 135.49 403.505 127.174 398.531 124.15C393.556 121.126 393.556 125.254 389.686 123.591C386.495 122.223 385.906 119.622 384.998 116.87C384.9 116.553 384.794 116.235 384.681 115.925C384.373 115.065 383.973 114.241 383.486 113.468",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M380.099 109.892C372.887 104.6 360.95 106.589 360.95 117.808C360.95 120.567 354.312 117.808 351.825 121.399C349.338 124.99 352.105 127.205 348.801 128.308C345.497 129.412 345.21 126.653 341.06 126.925C336.909 127.197 337.469 131.068 336.085 132.179C334.702 133.29 334.709 132.731 331.67 133.003C328.631 133.275 328.072 135.49 328.072 135.49H366.854",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.516 132.466C387.918 131.048 387.926 129.548 387.54 128.125C387.153 126.703 386.387 125.412 385.323 124.392C381.627 120.975 377.764 122.88 376.698 124.392C375.632 125.904 375.601 128.777 373.825 129.049C372.048 129.321 372.456 126.025 368.623 126.857C364.791 127.688 366.295 131.514 364.518 132.33C362.742 133.147 362.742 130.145 360.277 131.098C357.813 132.051 357.949 133.835 357.949 133.835",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M367.852 123.168C366.844 122.451 365.663 122.017 364.431 121.91C363.198 121.804 361.96 122.029 360.844 122.563C356.883 124.392 358.712 128.203 356.883 129.117C355.053 130.032 354.138 128.959 351.855 130.032C349.572 131.106 349.716 132.618 349.716 132.618",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.284 186.838C174.613 186.468 173.848 186.305 173.084 186.369C170.703 186.528 171.02 188.751 170.226 189.393C169.433 190.036 169.47 189.711 167.694 189.869C167.245 189.863 166.805 189.996 166.435 190.251C166.065 190.505 165.784 190.869 165.63 191.291H207.338C207.338 191.291 208.367 188.214 207.278 186.097",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.083 184.782C203.233 183.043 203.233 185.417 201.011 184.464C199.174 183.708 198.833 182.196 198.319 180.608L198.138 180.064C195.726 173.366 184.53 172.905 184.53 181.138C184.53 182.725 180.75 181.138 179.298 183.202C177.847 185.265 179.457 186.528 177.552 187.163",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M199.763 189.552C199.994 188.738 199.999 187.877 199.778 187.061C199.557 186.245 199.118 185.504 198.508 184.918C196.384 182.952 194.184 184.056 193.557 184.918C192.929 185.78 192.929 187.428 191.908 187.586C190.888 187.745 191.152 185.863 188.922 186.331C186.692 186.8 187.592 189 186.564 189.476C185.535 189.953 185.543 188.214 184.129 188.766C182.715 189.318 182.799 190.376 182.799 190.376",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.484 184.215C187.905 183.803 187.227 183.554 186.52 183.492C185.813 183.431 185.102 183.561 184.462 183.867C182.194 184.918 183.237 187.103 182.194 187.647C181.151 188.191 180.621 187.564 179.306 188.176C177.99 188.788 178.081 189.688 178.081 189.688",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.808 114.413C272.14 114.042 271.377 113.879 270.616 113.944C268.234 114.103 268.552 116.326 267.758 116.968C266.964 117.611 266.964 117.286 265.218 117.437C264.769 117.432 264.33 117.568 263.962 117.824C263.593 118.08 263.314 118.444 263.161 118.866H304.87C304.87 118.866 305.898 115.789 304.81 113.672",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M303.57 112.357C300.72 110.61 300.72 112.992 298.497 112.039C296.66 111.283 296.32 109.771 295.806 108.184L295.624 107.639C293.212 100.941 282.016 100.472 282.016 108.713C282.016 110.293 278.236 108.713 276.785 110.769C275.333 112.826 276.943 114.103 275.038 114.738",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M297.25 117.127C297.477 116.315 297.48 115.456 297.257 114.643C297.035 113.829 296.596 113.091 295.987 112.508C293.87 110.542 291.67 111.639 291.043 112.508C290.415 113.377 290.415 115.018 289.395 115.177C288.374 115.335 288.639 113.445 286.408 113.922C284.178 114.398 285.07 116.59 284.05 117.059C283.029 117.528 283.029 115.804 281.615 116.356C280.202 116.908 280.277 117.929 280.277 117.929",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M285.962 111.79C285.384 111.378 284.706 111.129 283.999 111.068C283.292 111.006 282.581 111.136 281.941 111.442C279.673 112.485 280.716 114.678 279.673 115.222C278.629 115.766 278.092 115.131 276.785 115.744C275.477 116.356 275.56 117.256 275.56 117.256",
    stroke: "#B2B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M436.928 153.4H272.279V430.86H436.928V153.4Z",
    fill: "#ADADAD",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M436.928 153.4H342.126V430.86H436.928V153.4Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M425.921 153.4H353.125V430.86H425.921V153.4Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M436.928 153.4H342.126V172.406H436.928V153.4Z",
    fill: "#ADADAD",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M412.555 396.764H366.499V430.867H412.555V396.764Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M412.555 396.764H389.527V430.867H412.555V396.764Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 184.532H283.218V203.515H304.122V184.532Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 179.066H283.218V187.322H304.122V179.066Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 184.532H313.095V203.515H333.999V184.532Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 179.066H313.095V187.322H333.999V179.066Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 220.971H283.218V239.954H304.122V220.971Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 215.505H283.218V223.761H304.122V215.505Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 220.971H313.095V239.954H333.999V220.971Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 215.505H313.095V223.761H333.999V215.505Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 257.411H283.218V276.394H304.122V257.411Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 251.945H283.218V260.2H304.122V251.945Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 257.411H313.095V276.394H333.999V257.411Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 251.945H313.095V260.2H333.999V251.945Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 293.85H283.218V312.833H304.122V293.85Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 288.376H283.218V296.632H304.122V288.376Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 293.85H313.095V312.833H333.999V293.85Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 288.376H313.095V296.632H333.999V288.376Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 330.289H283.218V349.272H304.122V330.289Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 324.815H283.218V333.071H304.122V324.815Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 330.289H313.095V349.272H333.999V330.289Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 324.815H313.095V333.071H333.999V324.815Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 366.721H283.218V385.704H304.122V366.721Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M304.122 361.255H283.218V369.51H304.122V361.255Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 366.721H313.095V385.704H333.999V366.721Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M333.999 361.255H313.095V369.51H333.999V361.255Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 184.532H349.776V203.515H370.68V184.532Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 179.066H349.776V187.322H370.68V179.066Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 184.532H379.661V203.515H400.564V184.532Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 179.066H379.661V187.322H400.564V179.066Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 184.532H409.538V203.515H430.442V184.532Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 179.066H409.538V187.322H430.442V179.066Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 220.971H349.776V239.954H370.68V220.971Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 215.505H349.776V223.761H370.68V215.505Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 220.971H379.661V239.954H400.564V220.971Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 215.505H379.661V223.761H400.564V215.505Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 220.971H409.538V239.954H430.442V220.971Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 215.505H409.538V223.761H430.442V215.505Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 257.411H349.776V276.394H370.68V257.411Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 251.945H349.776V260.2H370.68V251.945Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 257.411H379.661V276.394H400.564V257.411Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 251.945H379.661V260.2H400.564V251.945Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 257.411H409.538V276.394H430.442V257.411Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 251.945H409.538V260.2H430.442V251.945Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 293.85H349.776V312.833H370.68V293.85Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 288.376H349.776V296.632H370.68V288.376Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 293.85H379.661V312.833H400.564V293.85Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 288.376H379.661V296.632H400.564V288.376Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 293.85H409.538V312.833H430.442V293.85Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 288.376H409.538V296.632H430.442V288.376Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 330.289H349.776V349.272H370.68V330.289Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 324.815H349.776V333.071H370.68V324.815Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 330.289H379.661V349.272H400.564V330.289Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 324.815H379.661V333.071H400.564V324.815Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 330.289H409.538V349.272H430.442V330.289Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 324.815H409.538V333.071H430.442V324.815Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 366.721H349.776V385.704H370.68V366.721Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M370.68 361.255H349.776V369.51H370.68V361.255Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 366.721H379.661V385.704H400.564V366.721Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M400.564 361.255H379.661V369.51H400.564V361.255Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 366.721H409.538V385.704H430.442V366.721Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M430.442 361.255H409.538V369.51H430.442V361.255Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M430.177 396.711H348.756V407.038H430.177V396.711Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M430.177 393.725H348.756V404.052H430.177V393.725Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M316.543 139.127H272.188V166.471H316.543V139.127Z",
    fill: "#ADADAD",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M316.543 139.127H301.196V166.471H316.543V139.127Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M428.96 145.81H410.733V166.471H428.96V145.81Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M420.53 145.81H402.303V166.471H420.53V145.81Z",
    fill: "#ADADAD",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M440.942 153.4H268.272V166.471H440.942V153.4Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M440.935 153.4H337.68V166.471H440.935V153.4Z",
    fill: "white",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M342.126 153.4V158.889",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M344.946 153.4V158.889",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M344.946 160.37V164.559",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M347.773 153.4V158.889",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M347.773 160.605V164.491",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M350.411 160.605V163.054",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M350.6 153.4V158.889",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M353.798 157.498V158.889",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M353.987 153.4V156.522",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M342.126 159.992V163.243",
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M127.528 201.225C130.748 202.631 138.633 202.449 138.641 202.449C138.648 202.449 136.947 197.286 136.796 196.976C135.065 193.355 129.591 187.382 125.146 187.979C124.405 188.093 123.696 188.362 123.067 188.77C122.438 189.178 121.902 189.715 121.496 190.346C121.09 190.976 120.823 191.686 120.712 192.427C120.601 193.169 120.648 193.926 120.852 194.647C121.608 197.732 124.783 200.023 127.528 201.225Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M130.249 224.063C133.591 224.547 140.629 222.506 141.188 222.34C142.347 226.368 143.771 230.316 145.452 234.156C146.42 236.424 147.471 238.624 148.544 240.839C147.902 239.902 147.32 239.062 147.229 238.957C144.606 235.933 137.749 231.601 133.621 233.362C132.938 233.669 132.329 234.118 131.832 234.678C131.336 235.238 130.964 235.897 130.741 236.612C130.518 237.326 130.449 238.08 130.539 238.823C130.629 239.566 130.875 240.281 131.262 240.922C132.774 243.697 136.448 245.073 139.412 245.504C142.375 245.934 148.484 244.324 150.049 243.878C150.472 244.725 150.88 245.572 151.304 246.418C153.345 250.478 155.394 254.515 157.284 258.514C157.949 259.936 158.554 261.357 159.166 262.778C158.599 261.939 158.108 261.266 158.025 261.145C155.401 258.121 148.544 253.789 144.417 255.551C143.734 255.858 143.125 256.306 142.628 256.867C142.132 257.427 141.76 258.086 141.537 258.8C141.314 259.515 141.245 260.268 141.335 261.011C141.425 261.754 141.671 262.47 142.058 263.111C143.57 265.885 147.244 267.261 150.208 267.692C153.171 268.123 158.652 266.672 160.542 266.15C161.124 267.662 161.706 269.098 162.205 270.55C162.523 271.548 162.893 272.493 163.158 273.513L163.989 276.537C164.451 278.458 164.942 280.438 165.343 282.321C165.63 283.629 165.879 284.876 166.136 286.139C165.494 284.717 164.163 281.965 164.027 281.754C161.895 278.352 155.772 273.045 151.417 274.156C150.698 274.357 150.029 274.708 149.455 275.187C148.881 275.665 148.415 276.259 148.087 276.93C147.759 277.602 147.577 278.335 147.553 279.081C147.529 279.828 147.663 280.571 147.947 281.262C149.036 284.241 152.445 286.154 155.311 287.031C158.463 287.998 165.449 287.114 166.318 287.031C166.741 289.117 167.127 291.151 167.459 293.079C167.709 294.5 167.943 295.868 168.147 297.184H170.945C170.68 295.717 170.393 294.16 170.075 292.587C169.659 290.463 169.176 288.21 168.646 285.897C170.75 285.055 172.802 284.09 174.793 283.009C177.061 285.496 182.988 288.407 183.744 288.777C182.942 290.75 182.149 292.663 181.362 294.455C180.954 295.4 180.553 296.299 180.153 297.184H183.109C183.343 296.624 183.577 296.072 183.812 295.49C184.636 293.487 185.475 291.34 186.322 289.117C187.161 289.299 194.078 290.697 197.299 289.971C200.225 289.314 203.763 287.658 205.07 284.77C205.405 284.102 205.595 283.37 205.627 282.623C205.658 281.877 205.531 281.131 205.254 280.437C204.977 279.743 204.556 279.115 204.019 278.596C203.482 278.076 202.84 277.676 202.137 277.422C197.881 275.993 191.379 280.824 188.998 284.052C188.854 284.249 187.562 286.479 186.73 287.908C187.07 287 187.41 286.123 187.743 285.178C188.423 283.326 189.051 281.459 189.724 279.455C190.019 278.473 190.321 277.482 190.616 276.477C190.911 275.471 191.145 274.413 191.417 273.37C191.999 270.935 192.468 268.441 192.884 265.923C194.502 266.513 200.3 268.531 203.301 268.32C206.303 268.108 210.037 267.012 211.769 264.351C212.215 263.744 212.527 263.049 212.683 262.312C212.84 261.575 212.837 260.813 212.675 260.078C212.513 259.342 212.196 258.649 211.745 258.046C211.294 257.443 210.72 256.942 210.06 256.579C206.068 254.515 198.909 258.318 196.067 261.115C195.893 261.289 194.078 263.549 193.103 264.812C193.345 263.3 193.587 261.788 193.783 260.238C194.335 255.785 194.751 251.257 195.197 246.743C195.326 245.36 195.477 243.984 195.628 242.608C196.203 242.827 203.037 245.367 206.401 245.133C209.387 244.921 213.137 243.825 214.868 241.164C215.299 240.555 215.595 239.861 215.739 239.129C215.882 238.397 215.869 237.643 215.701 236.916C215.532 236.189 215.212 235.507 214.761 234.912C214.31 234.318 213.739 233.826 213.084 233.468C209.092 231.412 201.933 235.207 199.091 238.004C198.871 238.216 196.271 241.474 195.651 242.336C195.968 239.312 196.316 236.288 196.785 233.309C197.391 229.304 198.255 225.342 199.37 221.448C199.642 221.553 206.764 224.237 210.211 223.995C213.197 223.791 216.947 222.687 218.678 220.034C219.101 219.424 219.391 218.732 219.528 218.002C219.666 217.273 219.649 216.523 219.478 215.8C219.307 215.078 218.985 214.4 218.535 213.81C218.085 213.22 217.516 212.731 216.864 212.376C212.872 210.319 205.721 214.114 202.871 216.912C202.651 217.138 199.847 220.639 199.393 221.312C199.453 221.085 199.499 220.843 199.567 220.624C200.801 216.75 202.375 212.994 204.269 209.397C205.29 207.394 206.378 205.541 207.482 203.765C208.752 204.4 214.619 207.242 217.741 207.371C220.765 207.492 224.583 206.811 226.594 204.347C227.091 203.788 227.465 203.13 227.689 202.416C227.914 201.703 227.984 200.95 227.896 200.207C227.809 199.464 227.564 198.748 227.179 198.106C226.795 197.465 226.278 196.912 225.664 196.484C221.884 194.005 214.392 196.991 211.255 199.508C211.081 199.645 209.501 201.225 208.367 202.381C208.873 201.625 209.387 200.756 209.879 200.007C211.761 197.172 213.659 194.715 215.352 192.523C216.327 191.291 217.227 190.195 218.089 189.182C219.669 189.182 226.019 188.962 228.801 187.67C231.583 186.377 234.615 184.018 235.273 180.918C235.456 180.194 235.484 179.438 235.355 178.702C235.225 177.965 234.941 177.265 234.521 176.646C234.101 176.028 233.555 175.505 232.918 175.113C232.281 174.721 231.569 174.468 230.827 174.371C226.359 173.895 221.052 180.011 219.419 183.678C219.276 183.995 217.643 189.204 217.726 189.204H217.817C216.97 190.164 216.078 191.208 215.125 192.357C213.379 194.504 211.421 196.946 209.478 199.75C207.343 202.742 205.387 205.857 203.619 209.079C201.617 212.677 199.942 216.447 198.614 220.344L198.569 220.487C198.569 219.172 198.569 215.49 198.501 215.195C197.987 211.211 194.653 203.855 190.23 203.016C189.493 202.897 188.738 202.936 188.016 203.129C187.295 203.322 186.622 203.666 186.043 204.139C185.464 204.611 184.991 205.2 184.656 205.868C184.321 206.536 184.131 207.267 184.099 208.013C183.842 211.174 186.133 214.341 188.37 216.329C190.888 218.597 197.881 220.76 198.44 220.926C197.186 224.926 196.198 229.005 195.484 233.135C195.053 235.539 194.728 237.974 194.373 240.416C194.373 239.274 194.373 238.261 194.313 238.148C193.799 234.171 190.465 226.808 186.042 225.968C185.305 225.85 184.551 225.89 183.83 226.084C183.11 226.278 182.438 226.622 181.86 227.094C181.281 227.566 180.809 228.155 180.475 228.822C180.14 229.489 179.951 230.22 179.918 230.966C179.654 234.133 181.944 237.293 184.182 239.282C186.42 241.27 192.377 243.288 193.95 243.818C193.836 244.755 193.708 245.693 193.594 246.638C193.058 251.174 192.544 255.641 191.893 260.041C191.674 261.553 191.394 263.111 191.137 264.63C191.137 263.625 191.1 262.771 191.084 262.642C190.57 258.665 187.236 251.302 182.821 250.463C182.083 250.343 181.328 250.38 180.605 250.573C179.883 250.766 179.209 251.11 178.629 251.582C178.049 252.054 177.576 252.644 177.24 253.312C176.905 253.981 176.715 254.713 176.683 255.46C176.426 258.62 178.716 261.788 180.954 263.776C183.192 265.764 188.575 267.556 190.442 268.191C190.109 269.703 189.784 271.291 189.399 272.772C189.111 273.785 188.907 274.776 188.559 275.796C188.212 276.817 187.924 277.77 187.607 278.745C186.934 280.605 186.246 282.525 185.543 284.317C185.067 285.564 184.583 286.751 184.099 287.938C184.349 286.426 184.757 283.402 184.764 283.115C184.714 279.587 183.761 276.13 181.997 273.075C182.006 272.68 181.981 272.286 181.922 271.895C181.836 271.151 181.593 270.433 181.208 269.79C180.824 269.146 180.307 268.592 179.693 268.163C179.078 267.734 178.379 267.441 177.643 267.302C176.906 267.164 176.149 267.183 175.42 267.359C171.081 268.516 168.329 276.137 168.125 280.143C168.125 280.378 168.261 282.956 168.389 284.581C168.17 283.636 167.966 282.714 167.732 281.746C167.278 279.826 166.764 277.966 166.22 275.88C165.917 274.897 165.622 273.906 165.32 272.909C165.018 271.911 164.617 270.89 164.269 269.885C163.407 267.541 162.425 265.197 161.381 262.869C163.06 262.468 169.009 260.949 171.398 259.089C173.787 257.229 176.297 254.281 176.274 251.105C176.299 250.358 176.164 249.614 175.88 248.922C175.595 248.231 175.168 247.607 174.625 247.093C174.082 246.579 173.436 246.185 172.73 245.939C172.024 245.692 171.274 245.598 170.529 245.662C166.061 246.146 162.213 253.26 161.374 257.191C161.328 257.441 161.064 260.321 160.95 261.909C160.308 260.51 159.68 259.112 158.985 257.72C156.989 253.699 154.849 249.692 152.725 245.685C152.075 244.46 151.44 243.228 150.797 242.003C151.402 241.867 158.508 240.212 161.177 238.163C163.559 236.341 166.076 233.355 166.053 230.187C166.077 229.44 165.943 228.697 165.659 228.006C165.375 227.315 164.948 226.692 164.406 226.177C163.864 225.663 163.219 225.27 162.514 225.022C161.809 224.775 161.06 224.68 160.315 224.744C155.847 225.228 151.999 232.304 151.16 236.273C151.1 236.568 150.729 240.718 150.684 241.776C149.278 239.07 147.902 236.356 146.647 233.627C144.942 229.945 143.478 226.157 142.262 222.287C142.542 222.226 149.966 220.54 152.71 218.439C155.084 216.617 157.609 213.631 157.586 210.455C157.61 209.708 157.476 208.964 157.191 208.272C156.907 207.581 156.479 206.957 155.936 206.443C155.394 205.928 154.748 205.535 154.042 205.288C153.336 205.042 152.586 204.948 151.841 205.012C147.38 205.504 143.525 212.618 142.693 216.541C142.625 216.851 142.224 221.319 142.209 222.136C142.141 221.909 142.043 221.682 141.982 221.463C140.871 217.552 140.112 213.549 139.714 209.503C139.465 207.273 139.351 205.126 139.283 203.031C140.697 202.865 147.161 202.003 149.83 200.385C152.498 198.768 155.227 196.144 155.552 192.984C155.66 192.244 155.609 191.49 155.403 190.771C155.197 190.052 154.842 189.385 154.36 188.814C153.877 188.242 153.28 187.78 152.606 187.456C151.932 187.132 151.197 186.955 150.449 186.936C145.913 186.936 141.317 193.574 140.085 197.392C140.017 197.603 139.563 199.788 139.261 201.383C139.261 200.438 139.208 199.463 139.215 198.556C139.215 195.161 139.435 192.054 139.646 189.295C139.782 187.73 139.934 186.324 140.092 185.001C141.393 184.109 146.586 180.465 148.181 177.819C149.777 175.173 151.016 171.567 149.852 168.618C149.607 167.911 149.215 167.264 148.701 166.72C148.188 166.176 147.565 165.747 146.873 165.461C146.182 165.175 145.437 165.039 144.689 165.062C143.941 165.085 143.207 165.267 142.534 165.594C138.512 167.696 137.484 175.732 138.127 179.686C138.187 180.026 139.692 185.273 139.76 185.228L139.835 185.175C139.661 186.445 139.487 187.806 139.329 189.295C139.057 192.047 138.769 195.161 138.694 198.571C138.577 202.245 138.678 205.924 138.996 209.586C139.311 213.691 139.994 217.76 141.037 221.742C141.037 221.788 141.037 221.833 141.083 221.886C140.372 220.775 138.293 217.736 138.104 217.516C135.481 214.492 128.624 210.168 124.496 211.922C123.814 212.23 123.205 212.679 122.71 213.239C122.214 213.8 121.843 214.459 121.621 215.173C121.399 215.888 121.33 216.641 121.421 217.384C121.511 218.127 121.758 218.842 122.145 219.482C123.627 222.257 127.286 223.64 130.249 224.063Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M207.286 202.956C207.354 203.001 208.714 197.717 208.798 197.369C209.349 193.4 208.079 185.394 204.035 183.443C203.354 183.134 202.616 182.971 201.868 182.967C201.121 182.963 200.381 183.118 199.697 183.421C199.014 183.724 198.402 184.168 197.903 184.724C197.403 185.281 197.027 185.937 196.8 186.649C195.719 189.628 197.095 193.279 198.72 195.797C200.602 198.752 207.278 202.948 207.286 202.956Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M325.108 377.758C326.892 378.514 331.254 378.439 331.262 378.439C331.269 378.439 330.324 375.581 330.241 375.415C329.281 373.411 326.25 370.123 323.785 370.433C323.377 370.499 322.988 370.651 322.643 370.878C322.298 371.105 322.005 371.403 321.782 371.751C321.56 372.099 321.413 372.49 321.352 372.898C321.29 373.307 321.316 373.724 321.426 374.122C321.835 375.823 323.589 377.108 325.108 377.758Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M326.613 390.406C328.465 390.671 332.366 389.544 332.661 389.453C333.301 391.683 334.089 393.868 335.019 395.993C335.556 397.233 336.138 398.465 336.728 399.697C336.372 399.176 336.055 398.714 335.972 398.654C334.52 396.976 330.725 394.579 328.412 395.554C328.036 395.726 327.7 395.974 327.426 396.284C327.153 396.594 326.948 396.958 326.824 397.353C326.701 397.747 326.662 398.163 326.71 398.574C326.758 398.984 326.892 399.38 327.104 399.735C327.951 401.247 329.977 402.003 331.64 402.275C333.303 402.547 336.645 401.618 337.529 401.376L338.225 402.782C339.351 405.05 340.493 407.265 341.536 409.495C341.906 410.251 342.239 411.068 342.579 411.854C342.262 411.393 341.99 410.999 341.944 410.947C340.493 409.268 336.698 406.879 334.384 407.847C334.009 408.019 333.674 408.268 333.401 408.578C333.128 408.888 332.923 409.252 332.8 409.646C332.677 410.04 332.638 410.456 332.685 410.866C332.733 411.277 332.866 411.672 333.076 412.028C333.923 413.54 335.949 414.333 337.612 414.568C339.276 414.802 342.3 414.001 343.343 413.714C343.668 414.53 343.993 415.346 344.265 416.148C344.439 416.7 344.651 417.221 344.794 417.788C344.938 418.355 345.104 418.9 345.255 419.444C345.513 420.51 345.777 421.599 346.011 422.642C346.17 423.398 346.306 424.063 346.45 424.759C346.095 424.003 345.361 422.491 345.286 422.332C344.099 420.449 340.712 417.509 338.3 418.121C337.903 418.235 337.534 418.431 337.218 418.697C336.902 418.962 336.644 419.292 336.463 419.663C336.282 420.034 336.181 420.44 336.167 420.852C336.153 421.265 336.225 421.677 336.38 422.06C336.977 423.708 338.867 424.774 340.455 425.258C342.201 425.787 346.072 425.303 346.548 425.258C346.783 426.414 346.994 427.526 347.183 428.607C347.319 429.401 347.448 430.157 347.569 430.875H349.081C348.937 430.066 348.778 429.219 348.605 428.327C348.37 427.155 348.098 425.908 347.811 424.623C348.977 424.16 350.114 423.625 351.213 423.02C352.49 424.403 355.749 426.044 356.172 426.218C355.726 427.314 355.288 428.372 354.849 429.363L354.184 430.875H355.817C355.953 430.565 356.081 430.262 356.21 429.937C356.664 428.826 357.132 427.669 357.593 426.407C358.062 426.505 361.895 427.284 363.679 426.883C365.297 426.513 367.255 425.598 367.981 424.003C368.164 423.632 368.268 423.226 368.284 422.813C368.301 422.399 368.23 421.987 368.077 421.603C367.923 421.218 367.691 420.871 367.394 420.582C367.098 420.294 366.744 420.071 366.355 419.928C363.997 419.172 360.398 421.818 359.083 423.602C359 423.708 358.327 424.948 357.843 425.734C358.032 425.235 358.221 424.751 358.41 424.222C358.788 423.194 359.128 422.158 359.506 421.047C359.665 420.502 359.831 419.958 359.997 419.399C360.164 418.839 360.292 418.257 360.444 417.675C360.761 416.329 361.018 414.953 361.252 413.555C362.152 413.88 365.358 414.999 367.021 414.885C368.684 414.772 370.755 414.129 371.715 412.685C371.952 412.347 372.116 411.963 372.194 411.557C372.273 411.152 372.265 410.735 372.172 410.332C372.078 409.93 371.901 409.552 371.652 409.223C371.403 408.894 371.087 408.621 370.725 408.422C368.51 407.28 364.549 409.382 362.976 410.947C362.878 411.045 361.872 412.3 361.336 412.995C361.464 412.156 361.6 411.317 361.706 410.463C362.016 407.998 362.25 405.488 362.462 402.986C362.538 402.23 362.621 401.474 362.696 400.718C363.021 400.839 366.801 402.23 368.669 402.116C370.324 402.003 372.396 401.36 373.356 399.924C373.593 399.585 373.756 399.2 373.835 398.794C373.914 398.389 373.906 397.971 373.813 397.568C373.719 397.165 373.542 396.786 373.293 396.456C373.044 396.126 372.728 395.853 372.366 395.653C370.158 394.519 366.189 396.62 364.617 398.185C364.496 398.306 363.059 400.106 362.712 400.582C362.893 398.903 363.082 397.225 363.339 395.585C363.678 393.367 364.158 391.172 364.775 389.015C364.919 389.075 368.865 390.565 370.778 390.429C372.434 390.315 374.505 389.673 375.465 388.229C375.702 387.891 375.865 387.506 375.944 387.101C376.022 386.695 376.015 386.278 375.921 385.876C375.828 385.474 375.651 385.096 375.402 384.766C375.152 384.437 374.837 384.164 374.475 383.965C372.267 382.823 368.298 384.925 366.726 386.49C366.605 386.618 365.055 388.554 364.798 388.924C364.836 388.803 364.859 388.667 364.896 388.546C365.575 386.401 366.446 384.321 367.497 382.332C368.064 381.221 368.669 380.192 369.274 379.21C369.984 379.565 373.227 381.137 374.959 381.206C376.69 381.274 378.739 380.896 379.858 379.542C380.132 379.232 380.337 378.868 380.461 378.473C380.584 378.078 380.623 377.661 380.575 377.25C380.526 376.839 380.391 376.443 380.179 376.088C379.967 375.732 379.682 375.426 379.344 375.188C377.272 373.812 373.107 375.467 371.368 376.851C371.269 376.927 370.4 377.796 369.765 378.439C370.052 378 370.332 377.539 370.612 377.123C371.647 375.558 372.698 374.19 373.636 372.98C374.172 372.3 374.671 371.695 375.148 371.128C376.025 371.128 379.54 371.007 381.082 370.289C382.625 369.571 384.303 368.263 384.666 366.547C384.765 366.145 384.779 365.728 384.706 365.321C384.633 364.914 384.475 364.527 384.242 364.186C384.01 363.844 383.708 363.555 383.356 363.338C383.004 363.121 382.611 362.98 382.201 362.925C379.729 362.653 376.788 366.048 375.889 368.074C375.805 368.248 374.898 371.136 374.944 371.136H374.997C374.528 371.665 374.036 372.239 373.485 372.882C372.517 374.069 371.436 375.422 370.355 376.972C369.174 378.628 368.091 380.352 367.111 382.135C366.005 384.129 365.077 386.216 364.337 388.372C364.341 388.4 364.341 388.428 364.337 388.456C364.337 387.7 364.337 385.689 364.337 385.53C364.05 383.33 362.205 379.24 359.763 378.786C359.355 378.722 358.937 378.745 358.538 378.852C358.139 378.96 357.766 379.151 357.446 379.412C357.125 379.673 356.862 379.998 356.676 380.367C356.489 380.736 356.382 381.14 356.361 381.553C356.217 383.307 357.488 385.061 358.727 386.165C360.126 387.412 364.019 388.614 364.307 388.713C363.613 390.927 363.065 393.185 362.666 395.471C362.432 396.802 362.235 398.147 362.054 399.501C362.054 398.873 362.054 398.306 362.054 398.231C361.767 396.031 359.922 391.941 357.472 391.487C357.064 391.423 356.647 391.445 356.248 391.553C355.849 391.661 355.478 391.852 355.157 392.113C354.837 392.374 354.576 392.699 354.39 393.068C354.204 393.437 354.097 393.841 354.078 394.254C353.934 396.008 355.204 397.754 356.437 398.866C357.669 399.977 360.973 401.081 361.85 401.36C361.782 401.882 361.714 402.396 361.653 402.918C361.358 405.413 361.071 407.907 360.708 410.342C360.587 411.204 360.428 412.043 360.277 412.882C360.277 412.322 360.277 411.854 360.277 411.786C359.998 409.578 358.145 405.488 355.741 405.035C355.333 404.972 354.915 404.995 354.516 405.104C354.118 405.213 353.746 405.404 353.426 405.666C353.106 405.927 352.844 406.253 352.658 406.623C352.473 406.992 352.366 407.396 352.347 407.809C352.203 409.556 353.473 411.309 354.705 412.413C355.938 413.517 358.924 414.522 359.96 414.855C359.778 415.717 359.597 416.579 359.385 417.395C359.226 417.955 359.113 418.507 358.916 419.058L358.395 420.691C358.017 421.72 357.639 422.786 357.246 423.776C356.981 424.471 356.716 425.122 356.49 425.787C356.626 424.933 356.853 423.254 356.853 423.111C356.835 421.159 356.314 419.245 355.341 417.554C355.345 417.336 355.329 417.119 355.295 416.904C355.245 416.493 355.108 416.098 354.895 415.744C354.681 415.39 354.395 415.084 354.055 414.848C353.716 414.612 353.33 414.45 352.924 414.373C352.517 414.296 352.099 414.306 351.697 414.401C349.293 415.044 347.765 419.263 347.652 421.478C347.652 421.614 347.735 423.043 347.803 423.942C347.682 423.421 347.569 422.906 347.44 422.37C347.183 421.311 346.904 420.253 346.601 419.119C346.442 418.575 346.276 418.03 346.102 417.478C345.928 416.927 345.717 416.36 345.528 415.793C345.051 414.492 344.507 413.199 343.925 411.907C344.855 411.687 348.151 410.848 349.474 409.828C350.797 408.807 352.18 407.167 352.173 405.413C352.185 404.999 352.109 404.587 351.952 404.204C351.794 403.821 351.557 403.475 351.257 403.19C350.956 402.905 350.599 402.686 350.209 402.548C349.818 402.41 349.403 402.356 348.99 402.389C346.518 402.661 344.371 406.6 343.925 408.777C343.925 408.913 343.751 410.508 343.683 411.385C343.335 410.629 342.98 409.835 342.602 409.064C341.498 406.841 340.334 404.619 339.132 402.404C338.769 401.723 338.421 401.043 338.066 400.363C338.399 400.287 342.33 399.372 343.812 398.238C345.127 397.225 346.526 395.57 346.518 393.816C346.531 393.401 346.457 392.989 346.299 392.605C346.142 392.222 345.905 391.876 345.604 391.59C345.304 391.305 344.946 391.086 344.555 390.948C344.164 390.811 343.748 390.757 343.335 390.792C340.863 391.056 338.716 394.995 338.262 397.172C338.262 397.339 338.028 399.637 337.998 400.196C337.242 398.684 336.486 397.172 335.768 395.66C334.82 393.625 334.01 391.529 333.341 389.385C333.492 389.348 337.605 388.418 339.124 387.254C340.44 386.24 341.838 384.592 341.823 382.831C341.836 382.417 341.762 382.004 341.604 381.621C341.447 381.237 341.21 380.891 340.91 380.606C340.609 380.32 340.251 380.101 339.86 379.964C339.469 379.826 339.054 379.773 338.64 379.807C336.168 380.072 334.021 384.01 333.575 386.188C333.575 386.361 333.318 388.834 333.311 389.287C333.273 389.159 333.22 389.038 333.182 388.909C332.564 386.744 332.141 384.527 331.92 382.287C331.784 381.054 331.723 379.867 331.685 378.711C332.441 378.612 336.047 378.136 337.529 377.237C339.011 376.337 340.515 374.893 340.697 373.147C340.753 372.737 340.723 372.32 340.608 371.923C340.493 371.527 340.295 371.158 340.029 370.842C339.762 370.527 339.432 370.27 339.06 370.09C338.688 369.91 338.282 369.811 337.869 369.797C335.375 369.797 332.812 373.472 332.124 375.588C332.086 375.702 331.836 376.911 331.67 377.796C331.67 377.274 331.67 376.738 331.67 376.231C331.67 374.349 331.791 372.632 331.912 371.105C331.98 370.236 332.071 369.457 332.154 368.724C332.872 368.233 335.753 366.199 336.637 364.747C337.522 363.296 338.21 361.285 337.559 359.652C337.421 359.262 337.202 358.907 336.917 358.607C336.632 358.308 336.287 358.072 335.905 357.915C335.522 357.758 335.111 357.684 334.698 357.697C334.285 357.709 333.879 357.809 333.507 357.989C331.3 359.13 330.718 363.576 331.08 365.768C331.118 365.957 331.95 368.86 331.988 368.837H332.033C331.935 369.54 331.836 370.296 331.746 371.105C331.595 372.617 331.443 374.356 331.398 376.246C331.324 378.278 331.372 380.313 331.542 382.34C331.717 384.614 332.094 386.868 332.668 389.075V389.151C332.275 388.539 331.156 386.883 331.02 386.739C329.568 385.054 325.773 382.665 323.46 383.64C323.085 383.812 322.75 384.061 322.477 384.371C322.204 384.681 321.999 385.045 321.876 385.439C321.753 385.833 321.714 386.249 321.761 386.659C321.809 387.069 321.942 387.465 322.152 387.821C322.946 389.401 324.972 390.164 326.613 390.406Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M369.274 378.718C369.274 378.718 370.03 375.815 370.098 375.626C370.4 373.426 369.697 368.989 367.459 367.907C367.082 367.739 366.673 367.651 366.26 367.65C365.847 367.65 365.438 367.736 365.06 367.904C364.682 368.071 364.344 368.316 364.067 368.623C363.79 368.93 363.581 369.291 363.452 369.684C362.855 371.332 363.611 373.358 364.518 374.749C365.577 376.39 369.274 378.711 369.274 378.718Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M315.031 220.057H170.627C165.704 220.057 161.714 224.047 161.714 228.97V421.946C161.714 426.869 165.704 430.86 170.627 430.86H315.031C319.953 430.86 323.944 426.869 323.944 421.946V228.97C323.944 224.047 319.953 220.057 315.031 220.057Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M316.18 232.523H169.478V420.858H316.18V232.523Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M213.039 260.729H272.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M280.391 286.396H301.037",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M220.992 286.396H275.477",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M195.598 286.396H217.31",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M184.62 286.396H190.275",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M280.799 306.558H301.037",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M247.21 306.558H276.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M196.83 306.558H242.704",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M184.62 306.558H191.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M269.33 326.728H301.037",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M201.336 326.728H263.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M184.62 326.728H196.414",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M293.5 346.891H301.037",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M206.25 346.891H285.72",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M184.62 346.891H200.512",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M292.275 367.061H301.037",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M223.865 367.061H285.72",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M184.62 367.061H218.535",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M261.551 387.223H301.037",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M184.62 387.223H253.764",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M262.148 215.8C261.431 215.793 260.729 215.592 260.118 215.217C259.506 214.843 259.008 214.309 258.676 213.674C258.344 213.038 258.19 212.324 258.232 211.608C258.274 210.892 258.509 210.201 258.913 209.609C260.234 207.495 260.964 205.065 261.024 202.572C261.084 200.08 260.472 197.617 259.254 195.442C258.035 193.267 256.254 191.46 254.098 190.21C251.941 188.959 249.488 188.312 246.995 188.335C244.502 188.359 242.061 189.052 239.928 190.342C237.795 191.633 236.048 193.473 234.871 195.671C233.693 197.868 233.128 200.341 233.235 202.832C233.341 205.323 234.116 207.739 235.477 209.828C235.842 210.425 236.042 211.109 236.054 211.809C236.066 212.509 235.89 213.2 235.545 213.809C235.201 214.418 234.699 214.924 234.093 215.275C233.486 215.625 232.798 215.806 232.097 215.8H207.905L214.437 234.564H279.763L286.295 215.8H262.148ZM247.104 207.809C246.14 207.811 245.198 207.526 244.396 206.992C243.594 206.458 242.969 205.697 242.6 204.807C242.23 203.917 242.133 202.938 242.321 201.993C242.509 201.048 242.972 200.179 243.654 199.498C244.335 198.817 245.203 198.353 246.148 198.165C247.094 197.978 248.073 198.075 248.963 198.444C249.853 198.814 250.613 199.439 251.148 200.241C251.682 201.042 251.967 201.985 251.965 202.948C251.965 204.238 251.453 205.474 250.541 206.386C249.63 207.297 248.393 207.809 247.104 207.809Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M209.996 405.295C216.864 399.058 217.377 388.434 211.14 381.566C204.903 374.697 194.28 374.185 187.411 380.422C180.543 386.659 180.031 397.282 186.267 404.151C192.504 411.019 203.128 411.531 209.996 405.295Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M199.914 399.894C199.375 399.889 198.844 399.77 198.355 399.543C197.866 399.316 197.431 398.987 197.079 398.578L189.708 389.96C189.341 389.592 189.053 389.151 188.863 388.667C188.674 388.182 188.586 387.663 188.606 387.143C188.626 386.623 188.754 386.112 188.98 385.644C189.207 385.175 189.528 384.758 189.923 384.419C190.318 384.081 190.779 383.827 191.277 383.675C191.775 383.522 192.299 383.474 192.816 383.534C193.333 383.594 193.832 383.759 194.282 384.021C194.732 384.282 195.124 384.634 195.431 385.054L199.967 390.391L215.087 373.517C215.407 373.109 215.807 372.772 216.262 372.525C216.717 372.278 217.219 372.128 217.734 372.083C218.25 372.038 218.77 372.1 219.261 372.264C219.752 372.428 220.204 372.691 220.59 373.038C220.975 373.384 221.285 373.805 221.5 374.276C221.715 374.747 221.832 375.257 221.842 375.775C221.852 376.293 221.755 376.807 221.559 377.286C221.362 377.765 221.068 378.199 220.697 378.56L202.674 398.631C202.32 399.024 201.887 399.338 201.404 399.553C200.921 399.767 200.398 399.879 199.869 399.879L199.914 399.894Z",
    fill: "#F9A200"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M217.968 373.411C218.478 373.409 218.978 373.556 219.407 373.833C219.836 374.11 220.175 374.506 220.382 374.972C220.59 375.439 220.657 375.956 220.576 376.46C220.495 376.964 220.269 377.433 219.926 377.811L201.903 397.883C201.657 398.159 201.355 398.38 201.018 398.531C200.68 398.682 200.314 398.76 199.945 398.76C199.569 398.757 199.198 398.674 198.857 398.515C198.517 398.355 198.215 398.124 197.972 397.838L190.563 389.204C190.329 388.942 190.15 388.636 190.037 388.304C189.923 387.972 189.876 387.621 189.9 387.271C189.924 386.921 190.017 386.579 190.174 386.266C190.331 385.952 190.55 385.673 190.816 385.445C191.082 385.217 191.392 385.044 191.726 384.936C192.06 384.829 192.412 384.79 192.761 384.82C193.111 384.85 193.451 384.95 193.761 385.114C194.072 385.277 194.347 385.501 194.57 385.772L199.99 392.092L216.002 374.258C216.249 373.981 216.552 373.76 216.891 373.609C217.23 373.457 217.597 373.38 217.968 373.381M217.968 371.113C217.279 371.114 216.599 371.26 215.97 371.54C215.341 371.819 214.778 372.228 214.316 372.738L200.028 388.652L196.293 384.298C195.878 383.795 195.367 383.381 194.789 383.078C194.212 382.776 193.58 382.591 192.931 382.536C192.281 382.48 191.627 382.554 191.007 382.754C190.386 382.954 189.812 383.276 189.317 383.7C188.823 384.125 188.418 384.643 188.125 385.226C187.833 385.809 187.661 386.444 187.617 387.094C187.573 387.745 187.659 388.397 187.87 389.014C188.081 389.63 188.413 390.199 188.847 390.686L196.218 399.289C196.673 399.817 197.235 400.243 197.867 400.537C198.499 400.832 199.187 400.989 199.884 400.998H199.945C200.632 400.998 201.312 400.854 201.94 400.574C202.568 400.294 203.13 399.884 203.589 399.372L221.619 379.3C222.25 378.594 222.664 377.72 222.81 376.784C222.956 375.849 222.828 374.89 222.442 374.025C222.056 373.16 221.429 372.425 220.635 371.908C219.841 371.392 218.915 371.116 217.968 371.113Z",
    fill: "#263238"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M247.467 198.08V151.147",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M245.32 141.75V146.127L243.573 149.151C243.572 149.636 243.667 150.116 243.852 150.564C244.037 151.012 244.309 151.419 244.652 151.762C244.995 152.105 245.402 152.377 245.85 152.562C246.298 152.747 246.778 152.842 247.263 152.841C247.747 152.841 248.226 152.745 248.673 152.56C249.121 152.374 249.527 152.102 249.869 151.76C250.211 151.417 250.482 151.01 250.666 150.563C250.851 150.115 250.945 149.635 250.944 149.151V146.127",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M241.517 141.546H248.896V133.351H241.517V141.546Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M238.796 138.809H251.632V122.351H238.796V138.809Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M234.97 135.672H255.322V130.622H234.97V135.672Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M245.206 130.614H248.125L252.245 135.286L251.814 135.672H249.667L245.206 130.614Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M253.719 130.614L255.322 132.421V135.672H255.269L250.808 130.614H253.719Z",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M239.612 130.614H242.523L246.643 135.286L246.212 135.672H244.065L239.612 130.614Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M234.963 131.703V130.614H236.921L241.041 135.286L240.61 135.672H238.463L234.963 131.703Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M245.501 122.064V112.16",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M111.379 111.911H250.642V105.976L223.721 94.5757H111.379",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M223.721 111.911V94.5757L205.932 111.911V94.5757L223.721 111.911Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M205.955 111.911V94.5757L188.159 111.911V94.5757L205.955 111.911Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M188.181 111.911V94.5757L170.393 111.911V94.5757L188.181 111.911Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M170.415 111.911V94.5757L152.619 111.911V94.5757L170.415 111.911Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M152.642 111.911V94.5757L134.853 111.911V94.5757L152.642 111.911Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M134.876 111.911V94.5757L117.079 111.911V94.5757L134.876 111.911Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M406.56 288.225L397.2 314.058L396.603 313.906L391.311 310.073L389.353 312.001L391.409 322.109C391.409 322.109 399.725 326.388 401.237 326.108C402.365 325.876 403.472 325.555 404.549 325.148C404.549 325.148 409.78 289.193 409.916 288.497C410.052 287.802 409.175 285.881 406.56 288.225Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M409.085 423.224C409.085 423.224 406.469 427.208 404.337 428.886C402.205 430.565 397.2 432.984 395.809 434.11C394.418 435.237 395.053 436.242 395.514 436.726C395.976 437.21 402.432 437.565 405.932 437.573C409.432 437.58 415.76 436.061 415.76 436.061C415.76 436.061 418.557 436.507 419.268 436.152C419.979 435.796 420.425 435.002 420.538 433.763C420.651 432.523 420.243 425.522 420.243 425.522L409.085 423.224Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M416.599 434.209C413.878 434.647 413.341 435.267 408.064 436.053C403.725 436.703 397.291 435.902 394.955 435.486C394.96 435.718 395.011 435.946 395.108 436.157C395.204 436.367 395.342 436.556 395.514 436.711C395.991 437.195 402.432 437.55 405.932 437.558C409.432 437.565 415.76 436.046 415.76 436.046C415.76 436.046 418.557 436.492 419.268 436.136C419.979 435.781 420.417 434.995 420.53 433.778C419.213 433.846 417.9 433.99 416.599 434.209Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M411.36 426.15C411.36 426.15 408.336 424.804 406.295 427.072",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M407.913 425.008C407.913 425.008 410.241 426.83 409.931 428.788",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M409.1 428.251C409.1 428.251 406.718 427.148 405.1 429.007",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M406.386 427.322C406.386 427.322 408.215 428.834 407.958 430.421",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M407.376 430.383C407.376 430.383 405.176 429.348 401.714 430.572",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M404.594 429.438C404.759 429.605 404.884 429.807 404.96 430.03C405.036 430.252 405.06 430.488 405.031 430.721C405.002 430.954 404.92 431.178 404.792 431.375C404.664 431.571 404.493 431.737 404.292 431.858",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M426.329 427.004C426.329 427.004 425.036 431.631 424.575 432.296C424.114 432.961 421.029 436.832 420.999 438.185C420.969 439.538 421.959 440.582 424.416 441.141C426.873 441.701 430.684 441.897 433.723 440.514C436.762 439.13 438.13 438.677 438.894 436.56C439.657 434.443 439.151 427.344 439.151 427.344C439.151 427.344 429.663 420.351 426.329 427.004Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M438.894 436.537C439.188 435.389 439.325 434.207 439.302 433.022C438.667 434.031 437.954 434.989 437.17 435.887C435.658 437.543 433.103 439.38 428.174 439.743C425.633 439.963 423.107 439.188 421.128 437.58C421.059 437.768 421.016 437.964 420.999 438.163C420.999 439.546 421.959 440.559 424.416 441.119C426.873 441.678 430.684 441.875 433.723 440.491C436.762 439.108 438.13 438.654 438.894 436.537Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M433.004 425.432C433.004 425.432 428.862 425.227 427.561 427.7",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M428.468 425.492C428.468 425.492 432.029 426.248 432.573 427.941",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M432.18 428.456C432.18 428.456 428.03 428.259 426.73 430.724",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M427.637 428.516C427.637 428.516 431.198 429.272 431.749 430.965",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M431.356 431.48C431.356 431.48 427.206 431.283 425.906 433.748",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M426.813 431.54C426.813 431.54 430.374 432.296 430.918 433.989",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M401.525 336.178C401.525 336.178 403.112 360.227 403.793 366.978C404.473 373.729 406.129 389.295 406.265 389.711C406.401 390.126 406.817 395.63 406.817 395.63C406.817 395.63 406.408 397.838 406.96 402.661C407.512 407.484 409.16 417.539 409.16 417.539C409.16 417.539 407.784 417.811 407.92 418.915C408.056 420.019 408.608 423.05 408.608 423.05C408.608 423.05 413.847 424.834 415.359 424.978C416.871 425.122 419.895 424.978 419.895 424.978C419.895 424.978 421.135 422.906 420.999 421.81C420.713 420.456 420.344 419.12 419.895 417.811L420.583 409.684L421.74 376.488C421.74 376.488 426.011 408.86 426.699 411.196C427.387 413.532 428.075 417.244 428.075 417.244C428.075 417.244 426.699 418.348 426.699 419.036C426.699 419.724 426.979 424.547 426.979 424.547C426.979 424.547 429.731 422.339 432.347 422.755C434.962 423.171 439.241 426.203 439.241 426.203C439.41 424.805 439.686 423.423 440.065 422.067C440.617 420.276 439.514 415.732 439.234 414.507C438.917 413.105 438.871 411.655 439.098 410.236C439.378 408.996 439.514 405.14 439.65 403.901C439.786 402.661 439.514 371.801 439.514 371.801L442.326 336.458L402.258 335.218L401.525 336.178Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M416.206 276.893C416.206 276.893 407.694 280.794 407.134 282.185C406.575 283.576 403.702 311.744 402.046 323.009C400.391 334.273 401.101 337.267 401.101 337.267C401.101 337.267 402.878 340.933 420.258 340.336C437.639 339.739 443.793 337.146 444.027 335.611C444.261 334.076 444.503 336.019 444.503 334.953C444.503 333.887 445.803 283.636 444.503 280.559C443.203 277.482 435.87 272.402 433.738 272.168C431.606 271.933 416.206 276.893 416.206 276.893Z",
    fill: "#F9A200",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M430.26 274.594C425.059 275.872 416.206 278.73 416.206 278.73C416.206 278.73 407.694 282.631 407.134 284.022C406.94 284.8 406.801 285.59 406.718 286.388C410.498 284.241 419.336 279.251 422.315 278.314C424.741 277.565 427.235 277.059 429.761 276.802L439.597 283.364L443.725 283.47C443.725 283.47 434.464 275.313 431.848 274.61C431.322 274.527 430.787 274.522 430.26 274.594Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M402.039 324.71V324.846C401.751 326.804 401.555 328.565 401.411 330.176C410.139 331.939 419.052 332.614 427.947 332.186C437.019 331.635 442.054 331.302 444.617 331.136C444.617 329.586 444.685 327.787 444.722 325.798C438.659 326.456 414.996 328.505 402.039 324.71Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M408.253 334.137C408.313 335.21 408.404 336.254 408.518 337.267",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M410.838 309.204C409.644 316.341 408.003 323.432 408.17 331.748",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M413.016 300.132C413.016 300.132 412.131 303.821 411.148 309.287",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M386.42 340.525C386.42 340.525 388.158 343.61 391.251 340.177C392.914 338.34 399.166 319.251 399.166 319.251C399.166 319.251 386.964 338.552 386.42 340.525Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M374.747 282.82L382.851 280.015C382.851 280.015 382.768 297.403 383.948 301.538L385.119 305.689C385.119 305.689 377.242 292.549 375.556 288.165C373.87 283.78 374.747 282.82 374.747 282.82Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M391.5 308.032C391.5 308.032 390.064 304.063 387.607 304.88C385.15 305.696 383.343 305.636 383.154 306.732C382.965 307.828 389.353 312.024 389.353 312.024C389.353 312.024 393.881 311.737 391.5 308.032Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M394.524 326.774C394.524 326.774 386.541 339.981 386.435 340.525C386.435 340.525 380.961 331.257 373.583 319.901C366.204 308.546 359.264 281.693 359.264 281.693C361.38 279.561 364.158 278.209 367.142 277.86C372.328 277.165 374.112 277.369 374.112 277.369C374.112 277.369 379.056 294.855 384.53 302.914C388.149 308.101 392.308 312.891 396.936 317.203L399.204 319.251L394.524 326.774Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M373.417 305.091C378.154 306.844 382.982 308.343 387.879 309.582",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M368.994 303.458C368.994 303.458 369.629 303.708 370.702 304.101",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M376.894 301.742C376.894 301.742 382.073 306.936 387.478 307.964",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M403.309 315.071C403.309 315.071 396.686 311.994 395.62 311.88C394.554 311.767 389.119 313.884 388.529 314.36C387.939 314.836 387.697 315.872 388.408 316.016C389.119 316.159 390.298 315.305 390.298 315.305L393.375 314.715L394.796 315.539C394.796 315.539 389.829 318.495 389.353 319.448C388.877 320.4 388.053 322.162 388.529 322.517C389.005 322.873 389.24 323.704 389.943 323.704C390.317 323.71 390.691 323.685 391.062 323.629C391.959 323.486 392.801 323.102 393.496 322.517C394.554 321.572 396.921 321.928 396.921 321.928C396.921 321.928 399.763 322.873 400.474 322.638C401.328 322.26 402.156 321.826 402.953 321.338H404.254L403.309 315.071Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M388.529 322.517C388.529 322.517 391.062 319.879 391.349 319.539C391.636 319.198 395.93 317.036 395.93 317.036",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M389.943 323.704C389.943 323.704 393.375 320.68 393.617 320.499C393.859 320.317 396.747 319.153 396.747 319.153",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M442.696 282.51C442.696 282.51 438.085 280.998 434.894 285.942C431.704 290.886 429.791 314.821 429.791 314.821L403.331 315.071L403.8 322.404C403.8 322.404 428.869 325.11 433.715 325.11C438.561 325.11 439.869 325.934 440.459 324.165C441.048 322.396 446.265 300.843 446.975 293.986C447.686 287.129 444.942 282.986 442.696 282.51Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M403.596 336.594C403.596 336.594 396.293 335.49 395.877 336.314C395.462 337.138 395.877 348.41 396.565 349.128C397.253 349.847 401.94 350.784 403.316 349.952C404.692 349.121 405.524 348.577 405.796 347.889C406.068 347.201 406.076 338.522 405.524 337.418C405.327 337.098 405.036 336.847 404.691 336.699C404.346 336.552 403.963 336.515 403.596 336.594Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M412.267 337.97C412.267 337.97 411.156 349.136 412.955 349.816C414.962 350.431 417.056 350.712 419.154 350.648C419.842 350.504 422.322 350.096 422.738 348.992C423.154 347.889 423.146 339.21 422.874 338.408C422.602 337.607 412.955 336.866 412.267 337.97Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M429.625 339.21C429.625 339.21 430.177 351.744 430.449 352.296C430.721 352.848 435.96 356.295 436.92 356.152C437.881 356.008 445.599 355.192 445.992 353.672C446.386 352.152 447.368 339.898 446.544 338.552C445.72 337.206 443.929 336.624 442.273 336.488C440.617 336.352 430.978 337.728 430.978 337.728C430.607 337.757 430.26 337.926 430.009 338.201C429.757 338.476 429.62 338.837 429.625 339.21Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M419.759 273.763L414.082 276.84L416.093 280.506L413.25 298.242C413.25 298.242 430.056 276.363 430.283 276.008C431.375 275.257 432.52 274.585 433.707 273.997L432.642 269.62L430.872 270.096L419.759 273.763Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M413.764 249.344C413.764 249.344 412.744 252.497 412.744 252.92C412.797 253.491 412.883 254.059 413.001 254.621C413.001 254.621 409.856 259.043 410.022 259.293C410.188 259.542 412.063 261.508 412.063 261.508C412.063 261.508 412.23 268.138 413.084 268.229C413.938 268.32 419.464 268.312 419.464 268.312L418.95 278.004L431.621 270.693L431.878 262.188C431.878 262.188 435.28 257.849 435.28 255.641C435.28 253.434 434.94 253.003 434.94 253.003L413.764 249.344Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M434.94 252.995L421.4 250.659L421.506 251.635L420.992 256.314C420.992 256.314 424.56 253.85 425.24 253.51C425.921 253.169 427.281 255.551 426.518 256.995C425.754 258.439 423.199 260.397 423.199 260.397C423.199 260.397 426.011 263.285 428.899 263.421C429.889 263.483 430.882 263.401 431.848 263.179V262.143C431.848 262.143 435.25 257.804 435.25 255.596C435.25 253.389 434.94 252.995 434.94 252.995Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M413.59 252.655C413.998 252.413 414.478 252.323 414.945 252.401C415.413 252.478 415.838 252.718 416.146 253.079",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M414.445 255.974C414.678 255.974 414.868 255.517 414.868 254.954C414.868 254.39 414.678 253.933 414.445 253.933C414.211 253.933 414.021 254.39 414.021 254.954C414.021 255.517 414.211 255.974 414.445 255.974Z",
    fill: "#263238"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M417.083 268.131L422.269 267.533L419.464 270.852V268.304L417.083 268.131Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M427.115 254.273L431.848 263.217L434.085 261.077L429.837 254.016L427.115 254.273Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M412.093 247.303C412.093 247.303 406.098 248.059 406.839 248.331C407.58 248.603 438.531 258.114 438.531 258.114C438.248 257.141 438.041 256.147 437.911 255.143C437.911 254.387 439.151 249.571 438.667 244.619C438.183 239.667 427.705 236.9 422.511 236.409C417.317 235.917 414.709 238.39 414.195 241.111C413.709 243.242 413.005 245.317 412.093 247.303Z",
    fill: "#F9A200",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M420.682 249.896L415.216 247.93C415.216 247.93 418.391 240.71 418.278 239.834C418.213 239.289 418.178 238.741 418.172 238.193C418.172 238.193 418.278 236.772 423.093 237.324",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteBanner);
export default __webpack_public_path__ + "static/media/quote-banner.096d401ab9047033b0043ec63afdf661.svg";
export { ForwardRef as ReactComponent };